import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment resourcesListingEntry on Craft_pages_ResourcesListing_Entry {
    uid
    title
    uri

    pageHeaderTitle
    pageHeaderText
    pageHeaderImage {
      ...mainFileUploadsAsset
    }
    flipMask

    resourceCategory {
      uid
      title
      slug
    }

    resourceTopic {
      uid
      title
      slug
    }

    footerCTA {
      ...defaultCTAEntry
    }

    seomatic {
      ...entrySEO
    }
  }
`

export const resourcesListingEntry = gql`
  fragment resourcesListingEntry on pages_ResourcesListing_Entry {
    uid
    title

    pageHeaderTitle
    pageHeaderText
    pageHeaderImage {
      ...mainFileUploadsAsset
    }
    flipMask

    resourceCategory {
      uid
      title
      slug
    }

    resourceTopic {
      uid
      title
      slug
    }

    footerCTA {
      ...defaultCTAEntry
    }

    seomatic {
      ...entrySEO
    }
  }
`
